import React from 'react';
import ArticleField from '../ArticleField';
import StrapiMedia from '../StrapiMedia';

interface SlideShowProps {
    value: any[],
    onChange: (value: any[]) => void
}

const SlideShow = (props: SlideShowProps) => (
    <ArticleField label="SlideShow">
        <StrapiMedia type="image" multiple value={props.value} onChange={props.onChange} />
    </ArticleField>
);

export default SlideShow;